import React from 'react';
import dynamic from 'next/dynamic';
import getComponentId from '../../../helpers/get-component-id';

const TextBlock = dynamic(() => import('../../TextBlock'));
const ContentGroupSection = dynamic(() => import('../../ContentGroupSection'));

const buildDataSections = (items = []) => {
  const itemData = items.map((item, i) => {
    if (!item || !item.text || !item.label) return null;

    const sectionName = getComponentId(item.label || `section-${i}`, true, true);
    return {
      sectionName,
      label: item.label,
      sectionContent: (
        <ContentGroupSection key={sectionName} name={sectionName} disableChildCheck>
          <TextBlock html={item.text} name={`${sectionName}-text`} />
        </ContentGroupSection>
      )
    };
  });

  return itemData.filter(Boolean).reduce(
    (acc, { sectionName, label, sectionContent }) => {
      if (!sectionName || !sectionContent) return acc;
      acc.groupSections.push(sectionContent);
      acc.sectionsData.push([sectionName, label]);
      return acc;
    },
    { groupSections: [], sectionsData: [] }
  );
};

export default buildDataSections;
